export default __webpack_public_path__ + "static/media/hht1_ep16_timeline_q05_b.8c71bd86.png";